export default __webpack_public_path__ + "static/media/selectUnselected.5c1621de.svg";